/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

import VueMapbox from 'vue-mapbox'
import Mapbox from 'mapbox-gl'

Vue.use(VueMapbox, { mapboxgl: Mapbox })

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'

// GeoCoder
import Geocoder from '@pderas/vue2-geocoder'
Vue.use(Geocoder, {
  defaultCountryCode: 'ID',
  defaultLanguage:    'id',
  defaultMode:        'address',
  googleMapsApiKey:   'AIzaSyAFkfxKJQT5yWcX9cwlOI-qOSi0qXPNwZY'
})

// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)

//Quill Editor
import VueQuillEdtitor, { Quill } from 'vue-quill-editor'
import quillBetterTable from 'quill-better-table'
Quill.register('modules/better-table', quillBetterTable)
Vue.use(VueQuillEdtitor)

// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    region: 'ID',
    language: 'id',
    key: 'AIzaSyAFkfxKJQT5yWcX9cwlOI-qOSi0qXPNwZY',
    libraries: 'places'
  }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
import 'vue-select/dist/vue-select.css'

//Component v-select
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

// currency
import vueCurrencyDirective from 'vue-currency-directive'
Vue.directive('currency', vueCurrencyDirective)

Vue.config.productionTip = false

import mixins from './mixins/index'

Vue.mixin(mixins)

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
